import { render, staticRenderFns } from "./addHelper.vue?vue&type=template&id=7251150e&"
import script from "./addHelper.ts?vue&type=script&lang=ts&"
export * from "./addHelper.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports